import styled from '@emotion/styled';

const Container = styled.div`
  width: 100%;
  max-width: 1170px;
  padding: 0 15px;
  margin: 0 auto;
  padding: 0 15px;

  @media (max-width: 1200px) {
    max-width: 970px;
  }
`;

export { Container };
